// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file abacus/v2/fields.proto (package abacus.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file abacus/v2/fields.proto.
 */
export const file_abacus_v2_fields: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
	);

/**
 * @generated from enum abacus.v2.ExportField
 */
export enum ExportField {
	/**
	 * @generated from enum value: EXPORT_FIELD_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: EXPORT_FIELD_DATE = 1;
	 */
	DATE = 1,

	/**
	 * @generated from enum value: EXPORT_FIELD_SCANS = 2;
	 */
	SCANS = 2,

	/**
	 * @generated from enum value: EXPORT_FIELD_SHORT_URL_CLICKS = 3;
	 */
	SHORT_URL_CLICKS = 3,

	/**
	 * @generated from enum value: EXPORT_FIELD_VISITS = 4;
	 */
	VISITS = 4,

	/**
	 * @generated from enum value: EXPORT_FIELD_LANDING_PAGE_VIEWS = 5;
	 */
	LANDING_PAGE_VIEWS = 5,

	/**
	 * @generated from enum value: EXPORT_FIELD_VIEWS = 6;
	 */
	VIEWS = 6,

	/**
	 * @generated from enum value: EXPORT_FIELD_MODULE_VIEWS = 7;
	 */
	MODULE_VIEWS = 7,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONVERSIONS = 8;
	 */
	CONVERSIONS = 8,

	/**
	 * @generated from enum value: EXPORT_FIELD_UNIQUE_CONVERSIONS = 9;
	 */
	UNIQUE_CONVERSIONS = 9,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONVERSION_RATE = 10;
	 */
	CONVERSION_RATE = 10,

	/**
	 * @generated from enum value: EXPORT_FIELD_TOTAL_CONVERSION_RATE = 11;
	 */
	TOTAL_CONVERSION_RATE = 11,

	/**
	 * @generated from enum value: EXPORT_FIELD_UNIQUE_CONVERSION_RATE = 12;
	 */
	UNIQUE_CONVERSION_RATE = 12,

	/**
	 * @generated from enum value: EXPORT_FIELD_EXPERIMENT_CONVERSION_RATE = 13;
	 */
	EXPERIMENT_CONVERSION_RATE = 13,

	/**
	 * @generated from enum value: EXPORT_FIELD_BASELINE_CONVERSION_RATE = 14;
	 */
	BASELINE_CONVERSION_RATE = 14,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONTACT_CONVERSIONS = 15;
	 */
	CONTACT_CONVERSIONS = 15,

	/**
	 * @generated from enum value: EXPORT_FIELD_PURCHASE_CONVERSIONS = 16;
	 */
	PURCHASE_CONVERSIONS = 16,

	/**
	 * @generated from enum value: EXPORT_FIELD_FORM_CONVERSIONS = 17;
	 */
	FORM_CONVERSIONS = 17,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONTACTS_DOWNLOADED_CONVERSIONS = 18;
	 */
	CONTACTS_DOWNLOADED_CONVERSIONS = 18,

	/**
	 * @generated from enum value: EXPORT_FIELD_EXTERNAL_PIXEL_CONVERSIONS = 19;
	 */
	EXTERNAL_PIXEL_CONVERSIONS = 19,

	/**
	 * @generated from enum value: EXPORT_FIELD_FILES_DOWNLOADED_CONVERSIONS = 20;
	 */
	FILES_DOWNLOADED_CONVERSIONS = 20,

	/**
	 * @generated from enum value: EXPORT_FIELD_POLL_COMPLETED_CONVERSIONS = 49;
	 */
	POLL_COMPLETED_CONVERSIONS = 49,

	/**
	 * @generated from enum value: EXPORT_FIELD_ANONYMOUS_RESPONSES = 21;
	 */
	ANONYMOUS_RESPONSES = 21,

	/**
	 * @generated from enum value: EXPORT_FIELD_UNIQUE_VISITORS = 22;
	 */
	UNIQUE_VISITORS = 22,

	/**
	 * @generated from enum value: EXPORT_FIELD_LEADS_COLLECTED = 23;
	 */
	LEADS_COLLECTED = 23,

	/**
	 * @generated from enum value: EXPORT_FIELD_REVENUE = 24;
	 */
	REVENUE = 24,

	/**
	 * @generated from enum value: EXPORT_FIELD_GROUP = 25;
	 */
	GROUP = 25,

	/**
	 * @generated from enum value: EXPORT_FIELD_UNIQUE_CONTACTS = 26;
	 */
	UNIQUE_CONTACTS = 26,

	/**
	 * @generated from enum value: EXPORT_FIELD_TOTAL_CONTACTS = 27;
	 */
	TOTAL_CONTACTS = 27,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONTACTS = 29;
	 */
	CONTACTS = 29,

	/**
	 * @generated from enum value: EXPORT_FIELD_TOTAL = 30;
	 */
	TOTAL = 30,

	/**
	 * @generated from enum value: EXPORT_FIELD_VARIANT = 31;
	 */
	VARIANT = 31,

	/**
	 * @generated from enum value: EXPORT_FIELD_EMAIL = 32;
	 */
	EMAIL = 32,

	/**
	 * @generated from enum value: EXPORT_FIELD_NAME = 33;
	 */
	NAME = 33,

	/**
	 * @generated from enum value: EXPORT_FIELD_PHONE = 34;
	 */
	PHONE = 34,

	/**
	 * @generated from enum value: EXPORT_FIELD_LAST_INTERACTED_FLOW = 35;
	 */
	LAST_INTERACTED_FLOW = 35,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONVERSION_COUNT = 36;
	 */
	CONVERSION_COUNT = 36,

	/**
	 * @generated from enum value: EXPORT_FIELD_DISTINCT_CONVERSION_COUNT = 37;
	 */
	DISTINCT_CONVERSION_COUNT = 37,

	/**
	 * @generated from enum value: EXPORT_FIELD_FIRST_CONVERTED = 38;
	 */
	FIRST_CONVERTED = 38,

	/**
	 * @generated from enum value: EXPORT_FIELD_LAST_INTERACTED = 39;
	 */
	LAST_INTERACTED = 39,

	/**
	 * @generated from enum value: EXPORT_FIELD_ENTRYPOINT = 40;
	 */
	ENTRYPOINT = 40,

	/**
	 * @generated from enum value: EXPORT_FIELD_ORDER_NUMBER = 41;
	 */
	ORDER_NUMBER = 41,

	/**
	 * @generated from enum value: EXPORT_FIELD_QUANTITY = 42;
	 */
	QUANTITY = 42,

	/**
	 * @generated from enum value: EXPORT_FIELD_PURCHASED = 43;
	 */
	PURCHASED = 43,

	/**
	 * @generated from enum value: EXPORT_FIELD_TIME = 44;
	 */
	TIME = 44,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONTACT_SOURCE = 45;
	 */
	CONTACT_SOURCE = 45,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONTACT_COOKIE = 46;
	 */
	CONTACT_COOKIE = 46,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONTACT_CREATED = 47;
	 */
	CONTACT_CREATED = 47,

	/**
	 * @generated from enum value: EXPORT_FIELD_CURRENCY = 48;
	 */
	CURRENCY = 48,

	/**
	 * @generated from enum value: EXPORT_FIELD_CONTACT_BOT_STATUS = 50;
	 */
	CONTACT_BOT_STATUS = 50,
}

/**
 * @generated from enum abacus.v2.ExportField
 */
export type ExportFieldJson =
	| "EXPORT_FIELD_UNSPECIFIED"
	| "EXPORT_FIELD_DATE"
	| "EXPORT_FIELD_SCANS"
	| "EXPORT_FIELD_SHORT_URL_CLICKS"
	| "EXPORT_FIELD_VISITS"
	| "EXPORT_FIELD_LANDING_PAGE_VIEWS"
	| "EXPORT_FIELD_VIEWS"
	| "EXPORT_FIELD_MODULE_VIEWS"
	| "EXPORT_FIELD_CONVERSIONS"
	| "EXPORT_FIELD_UNIQUE_CONVERSIONS"
	| "EXPORT_FIELD_CONVERSION_RATE"
	| "EXPORT_FIELD_TOTAL_CONVERSION_RATE"
	| "EXPORT_FIELD_UNIQUE_CONVERSION_RATE"
	| "EXPORT_FIELD_EXPERIMENT_CONVERSION_RATE"
	| "EXPORT_FIELD_BASELINE_CONVERSION_RATE"
	| "EXPORT_FIELD_CONTACT_CONVERSIONS"
	| "EXPORT_FIELD_PURCHASE_CONVERSIONS"
	| "EXPORT_FIELD_FORM_CONVERSIONS"
	| "EXPORT_FIELD_CONTACTS_DOWNLOADED_CONVERSIONS"
	| "EXPORT_FIELD_EXTERNAL_PIXEL_CONVERSIONS"
	| "EXPORT_FIELD_FILES_DOWNLOADED_CONVERSIONS"
	| "EXPORT_FIELD_POLL_COMPLETED_CONVERSIONS"
	| "EXPORT_FIELD_ANONYMOUS_RESPONSES"
	| "EXPORT_FIELD_UNIQUE_VISITORS"
	| "EXPORT_FIELD_LEADS_COLLECTED"
	| "EXPORT_FIELD_REVENUE"
	| "EXPORT_FIELD_GROUP"
	| "EXPORT_FIELD_UNIQUE_CONTACTS"
	| "EXPORT_FIELD_TOTAL_CONTACTS"
	| "EXPORT_FIELD_CONTACTS"
	| "EXPORT_FIELD_TOTAL"
	| "EXPORT_FIELD_VARIANT"
	| "EXPORT_FIELD_EMAIL"
	| "EXPORT_FIELD_NAME"
	| "EXPORT_FIELD_PHONE"
	| "EXPORT_FIELD_LAST_INTERACTED_FLOW"
	| "EXPORT_FIELD_CONVERSION_COUNT"
	| "EXPORT_FIELD_DISTINCT_CONVERSION_COUNT"
	| "EXPORT_FIELD_FIRST_CONVERTED"
	| "EXPORT_FIELD_LAST_INTERACTED"
	| "EXPORT_FIELD_ENTRYPOINT"
	| "EXPORT_FIELD_ORDER_NUMBER"
	| "EXPORT_FIELD_QUANTITY"
	| "EXPORT_FIELD_PURCHASED"
	| "EXPORT_FIELD_TIME"
	| "EXPORT_FIELD_CONTACT_SOURCE"
	| "EXPORT_FIELD_CONTACT_COOKIE"
	| "EXPORT_FIELD_CONTACT_CREATED"
	| "EXPORT_FIELD_CURRENCY"
	| "EXPORT_FIELD_CONTACT_BOT_STATUS";

/**
 * Describes the enum abacus.v2.ExportField.
 */
export const ExportFieldSchema: GenEnum<ExportField, ExportFieldJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_fields, 0);

/**
 * @generated from enum abacus.v2.Dimension
 */
export enum Dimension {
	/**
	 * @generated from enum value: DIMENSION_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: DIMENSION_WORKSPACE_ID = 1;
	 */
	WORKSPACE_ID = 1,

	/**
	 * @generated from enum value: DIMENSION_CONVERSION_TYPE = 2;
	 */
	CONVERSION_TYPE = 2,

	/**
	 * @generated from enum value: DIMENSION_METADATA_VALUE = 3;
	 */
	METADATA_VALUE = 3,

	/**
	 * @generated from enum value: DIMENSION_SUITE_ID = 4;
	 */
	SUITE_ID = 4,

	/**
	 * @generated from enum value: DIMENSION_TAG = 5;
	 */
	TAG = 5,

	/**
	 * @generated from enum value: DIMENSION_COUNTRY = 6;
	 */
	COUNTRY = 6,

	/**
	 * @generated from enum value: DIMENSION_REGION = 29;
	 */
	REGION = 29,

	/**
	 * @generated from enum value: DIMENSION_ADMINISTRATIVE_AREA = 7;
	 */
	ADMINISTRATIVE_AREA = 7,

	/**
	 * @generated from enum value: DIMENSION_LOCALITY = 8;
	 */
	LOCALITY = 8,

	/**
	 * @generated from enum value: DIMENSION_POSTAL_CODE = 9;
	 */
	POSTAL_CODE = 9,

	/**
	 * @generated from enum value: DIMENSION_ENTRY_ID = 10;
	 */
	ENTRY_ID = 10,

	/**
	 * @generated from enum value: DIMENSION_ENTRY_TYPE = 11;
	 */
	ENTRY_TYPE = 11,

	/**
	 * @generated from enum value: DIMENSION_DAY_OF_WEEK = 12;
	 */
	DAY_OF_WEEK = 12,

	/**
	 * @generated from enum value: DIMENSION_TIME_OF_DAY = 13;
	 */
	TIME_OF_DAY = 13,

	/**
	 * @generated from enum value: DIMENSION_DEVICE_TYPE = 14;
	 */
	DEVICE_TYPE = 14,

	/**
	 * @generated from enum value: DIMENSION_ASSET_KEY = 15;
	 */
	ASSET_KEY = 15,

	/**
	 * @generated from enum value: DIMENSION_FORM_FIELD_VALUE = 16;
	 */
	FORM_FIELD_VALUE = 16,

	/**
	 * @generated from enum value: DIMENSION_VARIANT = 17;
	 */
	VARIANT = 17,

	/**
	 * @generated from enum value: DIMENSION_VERSION = 18;
	 */
	VERSION = 18,

	/**
	 * @generated from enum value: DIMENSION_DATE = 19;
	 */
	DATE = 19,

	/**
	 * @generated from enum value: DIMENSION_DAY = 20;
	 */
	DAY = 20,

	/**
	 * @generated from enum value: DIMENSION_HOUR = 21;
	 */
	HOUR = 21,

	/**
	 * @generated from enum value: DIMENSION_WEEK = 22;
	 */
	WEEK = 22,

	/**
	 * @generated from enum value: DIMENSION_MONTH = 23;
	 */
	MONTH = 23,

	/**
	 * @generated from enum value: DIMENSION_YEAR = 24;
	 */
	YEAR = 24,

	/**
	 * @generated from enum value: DIMENSION_CURRENT_TAG = 25;
	 */
	CURRENT_TAG = 25,

	/**
	 * @generated from enum value: DIMENSION_CURRENT_FOLDER_ID = 26;
	 */
	CURRENT_FOLDER_ID = 26,

	/**
	 * @generated from enum value: DIMENSION_CURRENCY_CODE = 27;
	 */
	CURRENCY_CODE = 27,

	/**
	 * @generated from enum value: DIMENSION_ALL_TAGS = 28;
	 */
	ALL_TAGS = 28,
}

/**
 * @generated from enum abacus.v2.Dimension
 */
export type DimensionJson =
	| "DIMENSION_UNSPECIFIED"
	| "DIMENSION_WORKSPACE_ID"
	| "DIMENSION_CONVERSION_TYPE"
	| "DIMENSION_METADATA_VALUE"
	| "DIMENSION_SUITE_ID"
	| "DIMENSION_TAG"
	| "DIMENSION_COUNTRY"
	| "DIMENSION_REGION"
	| "DIMENSION_ADMINISTRATIVE_AREA"
	| "DIMENSION_LOCALITY"
	| "DIMENSION_POSTAL_CODE"
	| "DIMENSION_ENTRY_ID"
	| "DIMENSION_ENTRY_TYPE"
	| "DIMENSION_DAY_OF_WEEK"
	| "DIMENSION_TIME_OF_DAY"
	| "DIMENSION_DEVICE_TYPE"
	| "DIMENSION_ASSET_KEY"
	| "DIMENSION_FORM_FIELD_VALUE"
	| "DIMENSION_VARIANT"
	| "DIMENSION_VERSION"
	| "DIMENSION_DATE"
	| "DIMENSION_DAY"
	| "DIMENSION_HOUR"
	| "DIMENSION_WEEK"
	| "DIMENSION_MONTH"
	| "DIMENSION_YEAR"
	| "DIMENSION_CURRENT_TAG"
	| "DIMENSION_CURRENT_FOLDER_ID"
	| "DIMENSION_CURRENCY_CODE"
	| "DIMENSION_ALL_TAGS";

/**
 * Describes the enum abacus.v2.Dimension.
 */
export const DimensionSchema: GenEnum<Dimension, DimensionJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_fields, 1);

/**
 * @generated from enum abacus.v2.Metric
 */
export enum Metric {
	/**
	 * @generated from enum value: METRIC_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: METRIC_SCANS = 1;
	 */
	SCANS = 1,

	/**
	 * @generated from enum value: METRIC_CLICKS = 2;
	 */
	CLICKS = 2,

	/**
	 * @generated from enum value: METRIC_VISITS = 3;
	 */
	VISITS = 3,

	/**
	 * @generated from enum value: METRIC_LANDING_PAGE_VIEWS = 4;
	 */
	LANDING_PAGE_VIEWS = 4,

	/**
	 * @generated from enum value: METRIC_VIEWS = 5;
	 */
	VIEWS = 5,

	/**
	 * @generated from enum value: METRIC_CONVERSIONS = 6;
	 */
	CONVERSIONS = 6,

	/**
	 * @generated from enum value: METRIC_ANONYMOUS_RESPONSES = 7;
	 */
	ANONYMOUS_RESPONSES = 7,

	/**
	 * @generated from enum value: METRIC_UNIQUE_VISITORS = 8;
	 */
	UNIQUE_VISITORS = 8,

	/**
	 * @generated from enum value: METRIC_UNIQUE_VIEWERS = 9;
	 */
	UNIQUE_VIEWERS = 9,

	/**
	 * @generated from enum value: METRIC_UNIQUE_CONVERSIONS = 10;
	 */
	UNIQUE_CONVERSIONS = 10,

	/**
	 * @generated from enum value: METRIC_CONVERSION_RATE = 11;
	 */
	CONVERSION_RATE = 11,

	/**
	 * @generated from enum value: METRIC_TOTAL_CONVERSION_RATE = 12;
	 */
	TOTAL_CONVERSION_RATE = 12,

	/**
	 * @generated from enum value: METRIC_UNIQUE_CONVERSION_RATE = 13;
	 */
	UNIQUE_CONVERSION_RATE = 13,

	/**
	 * @generated from enum value: METRIC_CONTACT_CONVERSIONS = 14;
	 */
	CONTACT_CONVERSIONS = 14,

	/**
	 * @generated from enum value: METRIC_PURCHASE_CONVERSIONS = 15;
	 */
	PURCHASE_CONVERSIONS = 15,

	/**
	 * @generated from enum value: METRIC_FORM_CONVERSIONS = 16;
	 */
	FORM_CONVERSIONS = 16,

	/**
	 * @generated from enum value: METRIC_CONTACTS_DOWNLOADED_CONVERSIONS = 17;
	 */
	CONTACTS_DOWNLOADED_CONVERSIONS = 17,

	/**
	 * @generated from enum value: METRIC_EXTERNAL_PIXEL_CONVERSIONS = 18;
	 */
	EXTERNAL_PIXEL_CONVERSIONS = 18,

	/**
	 * @generated from enum value: METRIC_FILE_DOWNLOADED_CONVERSIONS = 19;
	 */
	FILE_DOWNLOADED_CONVERSIONS = 19,

	/**
	 * @generated from enum value: METRIC_POLL_COMPLETED_CONVERSIONS = 20;
	 */
	POLL_COMPLETED_CONVERSIONS = 20,

	/**
	 * @generated from enum value: METRIC_HAS_BOT_DATA = 21;
	 */
	HAS_BOT_DATA = 21,
}

/**
 * @generated from enum abacus.v2.Metric
 */
export type MetricJson =
	| "METRIC_UNSPECIFIED"
	| "METRIC_SCANS"
	| "METRIC_CLICKS"
	| "METRIC_VISITS"
	| "METRIC_LANDING_PAGE_VIEWS"
	| "METRIC_VIEWS"
	| "METRIC_CONVERSIONS"
	| "METRIC_ANONYMOUS_RESPONSES"
	| "METRIC_UNIQUE_VISITORS"
	| "METRIC_UNIQUE_VIEWERS"
	| "METRIC_UNIQUE_CONVERSIONS"
	| "METRIC_CONVERSION_RATE"
	| "METRIC_TOTAL_CONVERSION_RATE"
	| "METRIC_UNIQUE_CONVERSION_RATE"
	| "METRIC_CONTACT_CONVERSIONS"
	| "METRIC_PURCHASE_CONVERSIONS"
	| "METRIC_FORM_CONVERSIONS"
	| "METRIC_CONTACTS_DOWNLOADED_CONVERSIONS"
	| "METRIC_EXTERNAL_PIXEL_CONVERSIONS"
	| "METRIC_FILE_DOWNLOADED_CONVERSIONS"
	| "METRIC_POLL_COMPLETED_CONVERSIONS"
	| "METRIC_HAS_BOT_DATA";

/**
 * Describes the enum abacus.v2.Metric.
 */
export const MetricSchema: GenEnum<Metric, MetricJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_fields, 2);
